module.exports = __webpack_public_path__ + "media/images/pages/about_us/team_members/pauline-65590a3c105ba95800c06eb7999f8f7d.png";